import { render } from "./FoodPicture.vue?vue&type=template&id=5e59ac62"
import script from "./FoodPicture.vue?vue&type=script&lang=js"
export * from "./FoodPicture.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__